













































import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { RootStoreHelper, StoreHelper } from '../../core/mixins';
import { Mounted } from '../../core/decorators';
@Component({
    components: {}
})
export default class ConfirmAction extends Mixins(StoreHelper, RootStoreHelper) {
    modalWidth: string = '600';
    @Prop() title: string;
    @Prop() deleteConfirmationMessage: string;
    @Prop() visible: boolean;
    @Prop() closeAction: boolean;
    @Mounted
    ready() {}
    @Emit()
    closeModal() {}
    @Emit()
    confirm() {}
}
